module.exports = __webpack_public_path__ + "static/media/PATS_5-480w.5c28ebf7.png";